import { useCallback } from 'react'
import { useI18n } from '../../i18n/I18nProvider'
import { translateInventory, type InventoryMessageKey } from './messages'

export function useInventoryTranslation() {
  const { language } = useI18n()
  const t = useCallback(
    (key: InventoryMessageKey, values?: Record<string, string | number>) =>
      translateInventory(language, key, values),
    [language],
  )
  return { language, t }
}
